// @ts-nocheck
import { ADD_ATTACHMENT_V2 } from 'config/constants';
import useSave from './useSave';

const useSaveAttachment = (onSuccess) => {
  const [
    saveAttachmentFile,
    { data: savedFileData, loading: isSaveFileLoading, error },
  ] = useSave(ADD_ATTACHMENT_V2, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onSuccess,
  });

  return {
    saveAttachmentFile,
    savedFileData,
    isSaveFileLoading,
    error,
  };
};

export default useSaveAttachment;
